import { Button } from '@chakra-ui/react';
import { Box, Container, Flex, Heading } from '@joinrepublic/dls-ui-kit';

import { containerSize, InterDisplayStyles } from '../../config/styles';
import { colors } from '../../config/styles';
import { MotionBox } from '../motion-box/motion-box';

export const JoinCommunity = () => {
  return (
    <Box
      as="section"
      id="start-investing"
      py={{ base: '6', sm: '32' }}
      bg={colors.brand.darkestBlue}
    >
      <Container maxW={containerSize}>
        <MotionBox>
          <Flex direction="column" align="center" textAlign="center" pt="4">
            <Heading
              as="h2"
              color="white"
              size={{ base: 'title-sm', sm: 'title-lg' }}
              sx={{
                ...InterDisplayStyles,
              }}
            >
              <Box as="span" fontWeight="400">
                Community unlocks capital.
              </Box>
              <br />
              <Box as="span" fontWeight="600">
                Republic is where it happens.
              </Box>
            </Heading>

            <Flex
              mt={{ base: '2', sm: '6' }}
              gap={{ base: '2', sm: '4' }}
              w="100%"
              maxW="340px"
            >
              <Button
                as="a"
                href="/register?after_sign_in=/investment-opportunities"
                variant="republic-primary"
                size="md"
                py="6"
                flex="1"
              >
                Start investing
              </Button>
              <Button
                as="a"
                href="/raise"
                variant="republic-secondary"
                color="white"
                bgColor="transparent"
                size="md"
                py="6"
                flex="1"
                _hover={{ color: 'white', borderColor: 'blue.500' }}
                _active={{ bgColor: 'transparent' }}
              >
                Raise capital
              </Button>
            </Flex>
          </Flex>
        </MotionBox>
      </Container>
    </Box>
  );
};
